import { type ReactNode } from 'react';

const ColumnNumber = {
    TWO: 'two',
    TWOLOCK: 'twolock',
    THREE: 'three',
    FOUR: 'four',
} as const;

interface ColumnsProps {
    columns: (typeof ColumnNumber)[keyof typeof ColumnNumber];
    content: ReactNode;
}

export const Columns = ({ columns, content }: ColumnsProps) => (
    <div className={`sds_section__container--columns sds_section__columns--${columns}`}>
        {content}
    </div>
);

Columns.ColumnNumber = ColumnNumber;
